import {PaymentProduct} from '@/interface';

export const getPrice = (item?: PaymentProduct) => {
  if (!item) {
    return {};
  }

  // amount: 원가 (vat 포함)
  // discount: 할인된 가격 (vat 포함), 서버에서 이 값으로 결제 처리함
  const originalPrice =
    item.discount && item.discount !== item.amount ? item.amount : undefined;
  const finalPrice = item.discount || item.amount;
  const vat = finalPrice / 11; // 부가세 (10%)
  const discountRate = originalPrice
    ? Math.round(((originalPrice - finalPrice) / originalPrice) * 100)
    : 0;

  return {
    originalPrice,
    finalPrice,
    vat,
    discountRate,
    discountedPrice: originalPrice ? originalPrice - finalPrice : 0,
    vatExtra: finalPrice - vat,
  };
};

export const getCardLogo = (cardCode?: string) => {
  if (!cardCode) {
    return undefined;
  }

  let card;

  try {
    card = require(`./card-logos/${cardCode}.png`);
  } catch (e) {
    card = '';
  }

  return card;
};

export const getCardName = (cardCode?: string) => {
  if (!cardCode?.trim()) {
    return '';
  } else if (cardCode.includes('카드') || cardCode.includes('페이')) {
    return cardCode;
  }

  switch (cardCode) {
    case '신협':
    case 'JCB':
    case '유니온페이':
    case '카카오뱅크':
    case '토스뱅크':
    case '케이뱅크':
      return cardCode;
    case '전북':
    case '제주':
    case '광주':
      return cardCode + '은행';
    case '국민':
      return 'KB국민카드';
    case '농협':
      return 'NH농협카드';
    case '기업비씨':
      return '기업 BC';
    case 'BC':
      return '비씨카드';
    case 'KDB':
      return 'KDB산업은행';
    case '수협':
      return 'Sh수협은행';
    case '우체국':
      return '우체국예금보험';
    case '새마을':
      return '새마을금고';
    case '저축':
      return '저축은행중앙회';
    case '비자':
      return 'VISA';
    case '다이너스':
      return '다이너스 클럽';
    default:
      return cardCode + '카드';
  }
};

export const getCardShortNumber = (cardNumber?: string) => {
  if (!cardNumber) {
    return '알 수 없음';
  }

  return cardNumber.substring(cardNumber?.length - 4);
};
